if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.sessionStorageCodeKey = 'cart-discount-last-used-code';
      this.sessionStorageParentKey = 'cart-discount-last-used-parent';
      this.sessionStorageAccordionKey = 'cart-discount-accordion-open';
    }

    connectedCallback() {
      if (window.SHOPIFY_STOREFRONT_API_URL == null || window.SHOPIFY_STOREFRONT_ACCESS_TOKEN == null) {
        return;
      }

      this.cartId = null;
      this.discounts = [];
      this.getCurrentCart();
    }

    init() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.input = this.form.querySelector('input');
      this.submitButton = this.form.querySelector('button');
      if (!this.input || !this.submitButton) return;
      this.removeAllButton = this.querySelector('.cart-discount__remove-all');
      this.cart = document.querySelector('cart-drawer-items') || this.querySelector('cart-items');
      this.errorElement = document.querySelectorAll(`.cart-discount__error`);
      this.discountWrapper = this.querySelector('.discounts');
      this.discountTemplate = this.querySelector('template.discount-template');
      this.bindRemoveDiscount = this.removeDiscount.bind(this);

      this.style.setProperty('--button-width', `${Math.ceil(this.submitButton.getBoundingClientRect().width)}px`);

      this.setRemoveButtons();
      this.initAccordionState();

      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      if (this.removeAllButton) this.removeAllButton.addEventListener('click', this.removeAllDiscounts.bind(this));
      this.classList.remove('hidden');
    }

    initAccordionState() {
      this.accordionDetails = this.querySelector('.cart-discount__accordion details');
      if (!this.accordionDetails) return;

      const savedState = sessionStorage.getItem(this.sessionStorageAccordionKey);
      if (savedState === 'true') {
        this.accordionDetails.open = true;
      }

      this.accordionDetails.addEventListener('toggle', () => {
        sessionStorage.setItem(this.sessionStorageAccordionKey, this.accordionDetails.open);
      });
    }

    getCurrentCart() {
      fetch(`${Shopify.routes.root}cart.js`)
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          this.cartToken = state.token;
          this.cartId = this.cartToken.split('?')[0];

          this.getCurrentDiscounts();
        })
        .catch((err) => {
          console.error('[CART-DISCOUNT]', err);
        });
    }

    getCurrentDiscounts() {
      const query = `
        query {
          cart(id: "gid://shopify/Cart/${this.cartToken}") {
            id
            discountCodes {
              code
              applicable
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .then((state) => {
          const discountCodes = state.data.cart.discountCodes || [];
          if (discountCodes && discountCodes.length > 0) {
            discountCodes.map((discount) => {
              if (discount.applicable) {
                this.discounts.push(this.filterCodeValue(discount.code));
              }
            });
          }

          this.init();
          this.checkDiscountApplication();
        })
        .catch((err) => {
          console.error(err);
        });
    }

    updateDiscounts(discounts) {
      const query = `
        mutation {
          cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${this.cartToken}", discountCodes: ${JSON.stringify(
        discounts
      )}) {
            cart {
              id
              discountCodes {
                code
                applicable
              }
            }
            userErrors {
              code
              field
              message
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .catch((err) => {
          console.error(err);
          if (this.errorElement) {
            this.errorElement.textContent = window.cartStrings.discountError;
          }
        })
        .finally(() => {
          this.cart.onCartUpdate();
          this.setLoadingForm(false);
        });
    }

    onFormSubmit(event) {
      event.preventDefault();
      this.setLoadingForm(true);
      const newDiscount = this.filterCodeValue(this.form.querySelector('input').value);

      sessionStorage.setItem(this.sessionStorageCodeKey, this.form.querySelector('input').value);
      sessionStorage.setItem(this.sessionStorageParentKey, this.dataset.parentSelector);
      const discountCodes = [...this.discounts, newDiscount];

      this.updateDiscounts(discountCodes);
    }

    removeDiscount(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      const code = this.filterCodeValue(event.currentTarget.dataset.code);
      const discountCodes = this.discounts.filter((discount) => discount !== code);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);
      this.newDiscount = null;

      this.updateDiscounts(discountCodes);
    }

    removeAllDiscounts(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);

      this.updateDiscounts([]);
    }

    checkDiscountApplication() {
      const lastAppliedDiscount = sessionStorage.getItem(this.sessionStorageCodeKey);
      const parentSelector = sessionStorage.getItem(this.sessionStorageParentKey);
      const errorElement = document.querySelector(`${parentSelector ? parentSelector : ''} .cart-discount__error`);

      if (lastAppliedDiscount) {
        if (!this.discounts.includes(this.filterCodeValue(lastAppliedDiscount)) && errorElement) {
          errorElement.innerHTML = window.cartStrings.discountInvalidCode.replace('[code]', lastAppliedDiscount);
        }
        requestAnimationFrame(() => {
          sessionStorage.removeItem(this.sessionStorageCodeKey);
          sessionStorage.removeItem(this.sessionStorageParentKey);
        });
      }

      if (this.discountTemplate && this.discountWrapper) {
        this.unsetRemoveButtons();

        this.discounts.forEach((discount) => {
          if (!this.shownDiscountCodes.includes(this.filterCodeValue(discount))) {
            const clone = this.discountTemplate.content.cloneNode(true);
            const item = clone.querySelector('.discount-template-wrapper');
            item.innerHTML = item.innerHTML.replace(/\[code\]/g, discount);
            this.discountWrapper.appendChild(item.querySelector('.discounts__discount'));

            const cartTotalsWrapper = document.querySelector('#CartTotals');
            const cartTotalsTemplate = document.querySelector('#TemplateCartTotalsDiscount');
            if (cartTotalsWrapper && cartTotalsTemplate) {
              const totalsClone = cartTotalsTemplate.content.cloneNode(true);
              const totalsItem = totalsClone.querySelector('.cart__totals-wrapper__item');
              totalsItem.querySelector('.subtotals__total').innerHTML = `${discount} <span class="subtotals__total__value">(${window.cartStrings.freeShipping})</span>`;
              totalsItem.querySelector('.subtotals__total-value').textContent = '-';
              cartTotalsWrapper.insertBefore(totalsItem, cartTotalsWrapper.querySelector('.totals'));
              const shippingRow = cartTotalsWrapper.querySelector('.cart__totals-wrapper__item__shipping');
              if (shippingRow) shippingRow.querySelector('.subtotals__total-value').textContent = window.cartStrings.freeLabel;
            }

            const cartDrawerTotalsWrapper = document.querySelector('#CartDrawerTotals');
            const cartDrawerTotalsTemplate = document.querySelector('#TemplateCartDrawerTotalsDiscount');
            if (cartDrawerTotalsWrapper && cartDrawerTotalsTemplate) {
              const totalsDrawerClone = cartDrawerTotalsTemplate.content.cloneNode(true);
              const totalsDrawerItem = totalsDrawerClone.querySelector('.cart__totals-wrapper__item');
              totalsDrawerItem.querySelector('.subtotals__total').innerHTML = `${discount} <span class="subtotals__total__value">(${window.cartStrings.freeShipping})</span>`;
              totalsDrawerItem.querySelector('.subtotals__total-value').textContent = '-';
              cartDrawerTotalsWrapper.insertBefore(totalsDrawerItem, cartDrawerTotalsWrapper.querySelector('.totals'));
              const shippingDrawerRow = cartDrawerTotalsWrapper.querySelector('.cart__totals-wrapper__item__shipping');
              if (shippingDrawerRow) shippingDrawerRow.querySelector('.subtotals__total-value').textContent = window.cartStrings.freeLabel;
            }
          }
        });

        this.setRemoveButtons();

        if (this.discounts.length > 0) {
          this.forceFreeShippingState();
        }
      }
    }

    forceFreeShippingState() {
      document.querySelectorAll('.cart-free-shipping[data-force-on-discount="true"]').forEach((el) => {
        const successClasses = el.dataset.successClass.split(' ').filter(Boolean);
        const defaultClasses = el.dataset.defaultClass.split(' ').filter(Boolean);

        defaultClasses.forEach((cls) => el.classList.remove(cls));
        successClasses.forEach((cls) => el.classList.add(cls));

        if (el.querySelector('.cart-free-shipping__icon--truck')) el.querySelector('.cart-free-shipping__icon--truck').classList.add('hidden');
        if (el.querySelector('.cart-free-shipping__icon--success')) el.querySelector('.cart-free-shipping__icon--success').classList.remove('hidden');
        if (el.querySelector('.cart-free-shipping__info__message')) el.querySelector('.cart-free-shipping__info__message').textContent = el.dataset.freeMessage;

        const bar = el.querySelector('.cart-free-shipping__bar__progress');
        if (bar) bar.style.width = '100%';
      });

      document.querySelectorAll('.totals__total-value[data-total-without-shipping]').forEach((el) => {
        el.textContent = el.dataset.totalWithoutShipping;
      });
    }

    setRemoveButtons() {
      this.removeDiscountButtons = this.querySelectorAll('.discount--remove');
      this.shownDiscountCodes = Array.from(this.removeDiscountButtons).map((button) =>
        this.filterCodeValue(button.dataset.code)
      );

      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    unsetRemoveButtons() {
      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    setLoadingForm(disable) {
      if (disable) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.removeAllButton) this.removeAllButton.setAttribute('disabled', true);
        if (this.removeAllButton) this.removeAllButton.setAttribute('aria-disabled', true);

        this.input.setAttribute('disabled', true);
        this.input.setAttribute('aria-disabled', true);

        this.removeDiscountButtons.forEach((button) => {
          button.setAttribute('disabled', true);
          button.setAttribute('aria-disabled', true);
        });
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

        if (this.removeAllButton) this.removeAllButton.removeAttribute('disabled');
        if (this.removeAllButton) this.removeAllButton.removeAttribute('aria-disabled');

        this.input.removeAttribute('disabled');
        this.input.removeAttribute('aria-disabled');

        this.removeDiscountButtons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        });
      }
    }

    filterCodeValue(code) {
      return code.trim().toLowerCase();
    }
  }

  customElements.define('cart-discount', CartDiscount);
}
